/* import __COLOCATED_TEMPLATE__ from './question-multiple-choice-modal.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { classNames } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { or, empty, readOnly } from '@ember/object/computed';
import { A as EmberArray } from '@ember/array';
import Component from '@ember/component';
import { QuestionType } from '@square/dashboard-protos/models/squareup/feedbacksurveys/common';
import { QuestionResponse } from '@square/dashboard-protos/models/squareup/feedbacksurveys/survey_response';
import { surveyRendered, surveyCompleted, surveyQuestionAnswered } from '@dashboard/shared-ui/events/feedback-surveys/event-catalog';
let QuestionMultipleChoiceModal = (_dec = classNames('dashboard-survey-question', 'dashboard-survey-question-single-select'), _dec2 = readOnly('modalOptions.survey'), _dec3 = readOnly('modalOptions.afterFade'), _dec4 = readOnly('survey.isCompleted'), _dec5 = readOnly('survey.currentQuestion'), _dec6 = readOnly('question.questionPrompt'), _dec7 = readOnly('question.questionType'), _dec8 = readOnly('question.questionChoice'), _dec9 = computed('questionChoice'), _dec10 = empty('selectedChoices'), _dec11 = or('isInputEmpty', 'responseSubmitted'), _dec(_class = (_class2 = class QuestionMultipleChoiceModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "eventstream", _descriptor, this);
    _defineProperty(this, "QuestionType", QuestionType);
    _defineProperty(this, "responseSubmitted", false);
    _initializerDefineProperty(this, "survey", _descriptor2, this);
    _initializerDefineProperty(this, "afterFade", _descriptor3, this);
    _initializerDefineProperty(this, "surveyCompleted", _descriptor4, this);
    _initializerDefineProperty(this, "question", _descriptor5, this);
    _initializerDefineProperty(this, "questionPrompt", _descriptor6, this);
    _initializerDefineProperty(this, "questionType", _descriptor7, this);
    _initializerDefineProperty(this, "questionChoice", _descriptor8, this);
    _initializerDefineProperty(this, "isInputEmpty", _descriptor9, this);
    _initializerDefineProperty(this, "submitDisabled", _descriptor10, this);
  }
  get selectedChoices() {
    return EmberArray();
  }
  get questionOptions() {
    return this.questionChoice.map(choice => {
      return {
        name: choice.value,
        label: choice.value,
        value: choice,
        selected: false
      };
    });
  }
  init(...args) {
    super.init(...args);
    this.eventstream.track(surveyRendered(this.survey?.surveyToken));
  }
  singleSelectResponse() {
    const singleSelectResponse = QuestionResponse.SingleSelectResponse.create({
      choice: this.selectedChoices,
      questionChoice: this.question?.questionChoice
    });
    return QuestionResponse.create({
      questionToken: this.question?.questionToken,
      questionPrompt: this.question?.questionPrompt,
      singleSelectResponse
    });
  }
  multipleSelectResponse() {
    const multipleSelectResponse = QuestionResponse.MultipleSelectResponse.create({
      choice: this.selectedChoices,
      questionChoice: this.question?.questionChoice
    });
    return QuestionResponse.create({
      questionToken: this.question?.questionToken,
      questionPrompt: this.question?.questionPrompt,
      multipleSelectResponse
    });
  }
  singleSelectCheckboxChanged(value) {
    this.set('selectedChoices', value);
  }
  multiSelectCheckboxChanged(changedOptionCheckedState, mutatedOptionsArray, changedOptionIndex, changedOptionValue) {
    if (changedOptionCheckedState) {
      this.selectedChoices.addObject(changedOptionValue);
    } else {
      this.selectedChoices.removeObject(changedOptionValue);
    }
  }
  submitResponse() {
    this.set('responseSubmitted', true);
    this.eventstream.track(surveyQuestionAnswered(this.survey?.surveyToken, this.question?.questionToken));
    const response = this.question?.questionType === QuestionType.MULTIPLE_SELECT ? this.multipleSelectResponse() : this.singleSelectResponse();
    this.survey.setResponseAndIncrementSurvey(response);
    this.eventstream.track(surveyCompleted(this.survey?.surveyToken));
    // Call afterfade with the response if it exists.
    this.afterFade && this.afterFade(response);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "eventstream", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "selectedChoices", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedChoices"), _class2.prototype), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "survey", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "afterFade", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "surveyCompleted", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "question", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "questionPrompt", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "questionType", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "questionChoice", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "questionOptions", [_dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "questionOptions"), _class2.prototype), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "isInputEmpty", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "submitDisabled", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "singleSelectCheckboxChanged", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "singleSelectCheckboxChanged"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "multiSelectCheckboxChanged", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "multiSelectCheckboxChanged"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "submitResponse", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "submitResponse"), _class2.prototype), _class2)) || _class);
export { QuestionMultipleChoiceModal as default };